var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicroModulatingBurner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C8.15906 17.5 6.66668 17.0123 6.66668 15C6.66668 12.3481 7.91668 10 9.16668 7.5C8.75001 9.16667 9.16668 15 12.0833 11.25C14.1667 15.4167 13.1323 17.5 10 17.5ZM10 17.5C14.2079 17.5 16.6667 15.0797 16.6667 10.9375C16.6667 6.79537 10 2.5 10 2.5C10 2.5 3.33334 6.79537 3.33334 10.9375C3.33334 15.0797 5.79213 17.5 10 17.5Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicroModulatingBurner);
export default __webpack_public_path__ + "static/media/icon-micro-modulating-burner.7c793e6bf224c3628713d02da83ccdbe.svg";
export { ForwardRef as ReactComponent };